import type { SearchStrategy } from "@touchscreen/api-client";

/**
 * `scoped` venues have no typo tolerance — "not in our catalogue" would be a lie when the real
 * issue is a misspelling against an exact/substring match. See touchscreen-api.md §GET /search.
 */
export function searchEmptyStateMessage(strategy: SearchStrategy): string {
  return strategy === "scoped" ? "No matches — check the spelling" : "No matches found";
}
